/**
 * players-select
 *
 * @author    Alexis Vedia <alexis.vedia@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import getSelectedOptions from "../common/get-selected-options";

export default (report_type, settingOptions = {}) => sb => {
    let settings,
        broadcasterSelect,
        selectAllBroadcasters,
        deselectAllBroadcasters;

    const fetchBroadcasters = function fetchBroadcasters() {
        let api_url = '';
        switch (report_type) {
            case "live_streaming_by_channel":
                api_url = "/tv-player-report/get-broadcasters-live-streaming-by-channel";
                break;
            case "programme_broadcaster_ranking":
                api_url = "/tv-player-report/get-broadcasters-programme-broadcaster-ranking";
                break;
            case "broadcasters_by_devices":
                api_url = "/tv-player-report/get-broadcasters-by-devices";
                break;
            case 'all_broadcasters':
            default:
                api_url = "/tv-player-report/get-broadcasters";
        };
        return sb.postApi(api_url).then(broadcasters => {
            sb.notify({ type: "broadcastersLoaded", data: broadcasters });

            return broadcasters;
        });
    };

    const populateBroadcastersSelect = function populateBroadcastersSelect(broadcasters) {
        let unavailableOption = '';
        let selectedOption = 'selected';
        let options = broadcasters.map(broadcaster => {
            if (settings.selected.length > 0) {
                selectedOption = (settings.selected.toLowerCase() === broadcaster.broadcaster_name.toLowerCase()) ? 'selected' : '';
            }

            if (broadcaster.broadcaster_id === null) {
                unavailableOption = `<option selected value="${broadcaster.broadcaster_id}">Unavailable</option>`;
                return;
            } else {
                return `<option ${selectedOption} value="${broadcaster.broadcaster_id}">${broadcaster.broadcaster_name}</option>`;
            }
        }).join("\n");

        options += unavailableOption;

        sb.append(broadcasterSelect, options);
        onBroadcastersSelectionChange(); // We've added broadcasters selected

        return broadcasters;
    };

    const onBroadcastersSelectionChange = function onBroadcastersSelectionChange() {
        sb.notify({
            type: "broadcastersSelectionChanged",
            data: [].map.call(
                getSelectedOptions(broadcasterSelect[0]),
                option => option.value
            )
        });
    };

    const selectOrDeselectAllBroadcasters = function selectOrDeselectAllBroadcasters(mustSelect) {
        for (let option of broadcasterSelect[0].getElementsByTagName('option')) {
            option.selected = mustSelect;
        }

        onBroadcastersSelectionChange();
    };

    const onSelectAllBroadcasters = function onSelectAllBroadcasters(e) {
        e.preventDefault();
        if(broadcasterSelect[0].disabled !== true) {
            selectOrDeselectAllBroadcasters(true);
        }
    };

    const onDeselectAllBroadcasters = function onDeselectAllBroadcasters(e) {
        e.preventDefault();
        selectOrDeselectAllBroadcasters(false);
    };

    return {
        init() {
            settings = (typeof settingOptions !== "object") ? {} : settingOptions;
            settings.selected = settingOptions.selected || '';

            broadcasterSelect = sb.find("#broadcaster");
            selectAllBroadcasters = sb.find("#broadcaster_select_all");
            deselectAllBroadcasters = sb.find("#broadcaster_deselect_all");

            sb.addEvent(broadcasterSelect[0], "change", onBroadcastersSelectionChange);

            sb.addEvent(selectAllBroadcasters, "click", onSelectAllBroadcasters);
            sb.addEvent(deselectAllBroadcasters, "click", onDeselectAllBroadcasters);

            fetchBroadcasters().then(populateBroadcastersSelect);
        },
        destroy() {
            sb.removeEvent(broadcasterSelect[0], "change", onBroadcastersSelectionChange);

            sb.removeEvent(deselectAllBroadcasters, "click", onDeselectAllBroadcasters);
            sb.removeEvent(selectAllBroadcasters, "click", onSelectAllBroadcasters);

            selectAllBroadcasters = null;
            deselectAllBroadcasters = null;
            broadcasterSelect = null;
        }
    }
};
